// @module BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems
define('BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems.View'
,	[
	'btm_pdprecentlyvieweditems_pdprecentlyvieweditems.tpl'
	
	,	'BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems.SS2Model'
	
	,	'Backbone'
    ]
, function (
	btm_pdprecentlyvieweditems_pdprecentlyvieweditems_tpl
	
	,	PDPRecentlyViewedItemsSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_pdprecentlyvieweditems_pdprecentlyvieweditems_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new PDPRecentlyViewedItemsModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
